import React, { FC, ReactNode } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import Copy from '../Copy'

export interface IDisplayValueProps {
  /**
   * Value displayed in the component
   * @example 46.24
   */
  children: ReactNode | undefined
  /**
   * @default false
   */
  enableCopy?: boolean
}

const useDisplayValueStyles = makeStyles({
  root: {
    display: 'flex',
  },
})

export const DisplayValue: FC<IDisplayValueProps> = ({ children, enableCopy = false }) => {
  const classes = useDisplayValueStyles()
  return (
    <Typography variant='body1' data-test='DisplayValue' component='div' className={classes.root}>
      <Box flex='0 0 auto'>{children}</Box>
      {enableCopy && (
        <Box flex='0 0 auto'>
          <Copy alignClass='right' copyText={JSON.stringify(children)} useIcon />
        </Box>
      )}
    </Typography>
  )
}

export default DisplayValue
